import React from 'react'
import Link from '../../utilities/link'
import { useTranslation } from 'react-i18next'
import { usePageContext } from '../../pageContext'


const ProductInfoForm = props => {

    const { t } = useTranslation()
    // Ricaviamo la lingua dal contesto della pagina 
    const { lang } = usePageContext()

    return (
      <div
        className="section is-lightgrey has-text-centered"
        style={{ padding: '0' }}
      >
        <section className="hero is-gradient">
          <div className="hero-body" style={{ padding: '2rem 1.5rem 0 1.5rem' }}>
            <div className="container">
              {/* <h1 className="title is-2 is-white">Inolta il tuo ordine</h1> */}
              <p
                className="subtitle is-5 is-white"
                style={{
                  marginBottom: '-20px',
                  padding: '10px',
                  backgroundColor: 'RGBA(33, 150, 243,1)',
                }}
              >
                {t('productInfoForm.formTitle')}
              </p>
            </div>
          </div>
        </section>

        <div className="container" style={{ padding: '40px 50px' }}>
          <p>
            <small>
              {t('productInfoForm.text1')}{' '}
              <a href="mailto:info@ctaelectronics.com">
                {t('productInfoForm.text2')}
              </a>
            </small>
          </p>
          <form
            method="POST"
            name="productinfo"
            netlify-honeypot="bot-field"
            data-netlify="true"
            action={`/${lang}/grazie`}
          >
            <input type="hidden" name="form-name" value="productinfo" />
            <input type="hidden" name="bot-field" />
            <input type="hidden" name="prodotto-di-interesse" value={props.product} />
            <div className="field is-horizontal">
              <div className="field-body">
                <div className="field">
                  <label className="label">
                    {t('projectFormFields.firstName')}
                  </label>
                  <input className="input" type="text" name="firstname"></input>
                </div>
                <div className="field">
                  <label className="label">
                    {t('projectFormFields.lastName')}
                  </label>
                  <input className="input" type="text" name="lastname"></input>
                </div>
              </div>
            </div>
            <div className="field is-horizontal">
              <div className="field-body">
                <div className="field">
                  <label className="label">
                    {t('projectFormFields.role')}
                  </label>
                  <input className="input" type="text" name="role"></input>
                </div>
                <div className="field">
                  <label className="label">
                    {t('projectFormFields.companyName')}
                  </label>
                  <input
                    className="input"
                    type="text"
                    name="companyname"
                  ></input>
                </div>
              </div>
            </div>
            <div className="field is-horizontal">
              <div className="field-body">
                <div className="field">
                  <label className="label">
                    {t('projectFormFields.phone')}
                  </label>
                  <input
                    className="input"
                    type="text"
                    name="phonenumber"
                  ></input>
                </div>
                <div className="field">
                  <label className="label">
                    {t('projectFormFields.email')}
                  </label>
                  <input className="input" type="email" name="email"></input>
                </div>
              </div>
            </div>
            <div className="field">
              <label className="label">
                {t('projectFormFields.message')}
              </label>
              <div className="control">
                <textarea
                  className="textarea"
                  name="message"
                  placeholder="Textarea"
                ></textarea>
              </div>
            </div>

            <div className="field">
              <div className="control">
                <label className="checkbox">
                  <input type="checkbox" name="privacy" />{' '}
                  <small>
                    {t('projectFormFields.privacy')}{' '}
                    <Link to={`/privacy`} style={{ color: '#444' }}>
                      Privacy Policy
                    </Link>
                    .
                  </small>
                </label>
              </div>
            </div>

            <button
              type="submit"
              className="button is-primary is-medium is-fullwidth"
            >
              {t('projectFormFields.send')}
            </button>
          </form>
        </div>
      </div>
    )
  }

export default ProductInfoForm
